<template>
    <content-wrapper>
        <Content class="mt-3">
            <b-card header-bg-variant="dark">
                <template #header>
                    <b-row class="align-items-center justify-content-between">
                        <b-col>
                            <h6 class="mb-0">Permits ODOL Gate</h6>
                        </b-col>

                        <!-- button add should be hidden -->
                        <!-- <b-col md="1">
                            <b-button variant="outline-light" @click.prevent="openPermitForm()">
                                <b-icon icon="plus-circle-fill"></b-icon>
                                Add
                            </b-button>
                        </b-col> -->
                    </b-row>
                </template>

                <div class="form-group row">
                    <label class="col-sm-1 col-form-label">Search</label>
                    <div class="col-sm-5 mb-3">
                        <b-form-select
                            v-model="searchForm.type"
                            :options="options.search"
                        ></b-form-select>
                    </div>
                    <div class="col-sm-6 mb-3">
                        <b-form-input
                            v-model.trim="searchForm.keywords"
                            placeholder="Keywords"
                            @keydown.enter="applySearch"
                        ></b-form-input>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-1 col-form-label">Filter</label>
                    <div class="col-sm-4 mb-3">
                        <b-form-datepicker
                            id="startDateOdol"
                            v-model="searchForm.startDate"
                            :max="searchForm.endDate"
                            locale="en-US"
                            label-no-date-selected="Start Date"
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        ></b-form-datepicker>
                    </div>
                    <div class="col-sm-4 mb-3">
                        <b-form-datepicker
                            id="endDateOdol"
                            v-model="searchForm.endDate"
                            :min="searchForm.startDate"
                            locale="en-US"
                            label-no-date-selected="End Date"
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        ></b-form-datepicker>
                    </div>

                    <div class="col-sm-3 d-flex flex-wrap flex-row-reverse mb-3 justify-content-between" style="gap: 0.5rem;">
                        <b-form-radio-group
                            buttons
                            button-variant="outline-primary"
                            :options="options.status"
                            name="radios-btn-status-odol"
                            v-model="searchForm.status"
                            @change="applySearch"
                        >
                        </b-form-radio-group>
                        <b-form-radio-group
                            buttons
                            button-variant="outline-primary"
                            :options="options.directions"
                            name="radios-btn-direction-odol"
                            v-model="searchForm.direction"
                            @change="applySearch"
                        >
                        </b-form-radio-group>
                    </div>

                </div>

                <div class="form-group row">
                    <b-col class="col-sm-2 offset-sm-10 mb-3">
                        <b-button variant="info" block @click="applySearch">
                            Search
                        </b-button>
                    </b-col>
                </div>

                <b-table
                    :per-page="pagination.per_page"
                    :current-page="pagination.current"
                    ref="table"
                    id="table"
                    :items="loadPage"
                    :fields="columns"
                    :busy.sync="isLoading"
                    striped
                    borderless
                    outlined
                    hover
                    show-empty
                    empty-text="No records found..."
                    stacked="sm"
                    fixed
                    class="mb-3"
                >
                    <template #table-colgroup>
                        <col style="width: 25%">
                        <col style="width: 25%">
                        <col style="width: 25%">
                        <col style="width: 25%">
                    </template>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner label="Loading..." type="grow"></b-spinner>
                        </div>
                    </template>
                    <template #cell(direction)="data">
                        <b-badge v-if="laneBadgeVariant(data.item.direction)" :variant="laneBadgeVariant(data.item.direction)">
                            {{ data.item.direction }}
                        </b-badge>
                        <span v-else>{{ data.item.direction || '-' }}</span>
                    </template>
                </b-table>

                <div class="form-group row justify-content-end">
                    <label class="col-sm-1 col-form-label">Per Page</label>
                    <div class="col-sm-2 mb-3">
                        <b-form-select
                            :value="pagination.per_page"
                            :options="options.pagination"
                            @change="(v) => { pagination.per_page = v; pagination.current = 1; $refs.table.refresh(); }"
                        ></b-form-select>
                    </div>
                    <div class="pr-2">
                        <simple-pagination
                            v-model="pagination.current"
                            :disable-prev="pagination.current === 1"
                            :disable-next="pagination.at_last_page"
                        />
                    </div>
                </div>
            </b-card>
        </Content>

        <!-- PERMIT FORM  -->
        <b-modal
            centered
            header-bg-variant="info"
            id="permitModal" size="lg"
            :title="'Permit Form ' + (this.permit.company !==undefined ? this.permit.company : '')"
            no-close-on-backdrop
            no-close-on-esc
            hide-header-close
        >
            <b-row>
                <b-col v-if="can('superadmin|control_room')">
                    <b-form-group
                        label="Owner"
                        label-for="owner_name"
                    >
                        <MemberDropDown v-model="$v.owner.$model"
                                        v-if="!isReadOnly"
                                        :state="validateState('owner')"

                                        type='tes'
                                        @input="loadVehicleByMember"
                        ></MemberDropDown>
                        <b-form-input
                            v-else
                            :disabled="isReadOnly"
                            id="owner_name"
                            :readonly="isReadOnly"
                            v-model="owner.company_name"
                            autocomplete="off"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                <b-form-group
                    label="Vehicle"
                    label-for="lic_plate"
                    label-class="required"
                >
                    <b-skeleton-wrapper :loading="isLoadingVehicle">
                        <template #loading>
                            <b-skeleton type="input"></b-skeleton>
                        </template>

                        <b-form-input
                            :disabled="options.memberVehicles.length === 0"
                            id="lic_plate"
                            list="vehicle-list"
                            v-model="$v.permit.lic_plate.$model"
                            required
                            :state="validateState('permit', 'lic_plate')"
                            :readonly="readonly.lic_plate"
                            autocomplete="off"
                            v-uppercase
                        ></b-form-input>
                        <b-form-invalid-feedback>
                            This field is required
                        </b-form-invalid-feedback>
                        <datalist id="vehicle-list">
                            <option
                            v-for="vehicle in options.memberVehicles"
                            :key="vehicle.id"
                            :value="vehicle.lic_plate">
                            {{ vehicle.lic_plate }}
                            </option>
                        </datalist>
                    </b-skeleton-wrapper>
                </b-form-group>
                </b-col>
                <b-col>
                <b-form-group
                    label="Date"
                    label-for="date"
                    label-class="required"
                >
                    <b-form-datepicker
                        id="date"
                        :aria-disabled="isReadOnly"
                        :aria-readonly="isReadOnly"
                        v-model="$v.permit.permit_date.$model"
                        locale="en-US"
                        :state="validateState('permit', 'permit_date')"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    ></b-form-datepicker>
                    <b-form-invalid-feedback>
                    This field is required
                    </b-form-invalid-feedback>
                </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="3">
                    <b-form-group class="d-block"
                                    label-for="direction"
                                    label-class="required"
                                    label="Direction"
                                    :disabled="isReadOnly"
                                    :state="validateState('permit', 'direction')"
                    >
                        <b-form-radio-group
                            v-model="$v.permit.direction.$model"
                            :options="options.directions"
                            name="radios-btn-direction"
                            :state="validateState('permit', 'direction')"
                            :disabled="isReadOnly"
                        >
                            <b-form-invalid-feedback :state="validateState('permit', 'direction')">
                                This field is required
                            </b-form-invalid-feedback>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
                <b-col class="mt-4" v-if="!isReadOnly">
                <b-button v-b-toggle.collapse-container variant="primary" :disabled="permit.container.length>0">
                    <i class="fa fa-plus"></i> Container
                </b-button>
                </b-col>
            </b-row>
            <b-collapse id="collapse-container" v-model="isContainerVisible">
                <b-form-group
                    label="Container"
                    label-for="best"
                >
                    <b-input-group>
                        <b-form-input
                            id="best"
                            v-model.trim="$v.container.$model"
                            type="text"
                            :state="validateState('container')"
                            maxLength="15"
                            :disabled="permit.container.length===2"
                            v-uppercase
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button variant="primary"
                                    @click="addContainerToList"
                                    :disabled="addingToContainer || permit.container.length === 2"
                            >
                                <i class="fa fa-plus" v-if="!addingToContainer"></i>
                                <i class="fa fa-refresh spinner-border spinner-border-sm" v-else></i>
                            </b-button>
                        </b-input-group-append>
                        <b-form-invalid-feedback>
                            This field is required and its max length is 15 characters
                        </b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
                <b-table
                    ref="container"
                    id="container"
                    :items="permit.container"
                    :fields="permitContainer"
                    striped
                    borderless
                    outlined
                    hover
                    show-empty
                    empty-text="Empty container list..."
                    stacked="sm"
                    class="mb-3"
                >
                    <template #cell(action)="data">
                        <b-button variant="primary"
                                    size="sm"
                                    class="mr-3"
                                    @click="showContainerInfo({ containers: data.item, direction: permit.direction, status: permit.pass_status })"
                        >
                            <i class="fa fa-receipt"></i>
                            Documents
                        </b-button>
                        <b-button variant="danger"
                                    size="sm"
                                    v-if="!isReadOnly"
                                    @click="permit.container.splice(data.index,1)"
                        >
                            <i class="fa fa-trash"></i>
                            Delete
                        </b-button>
                    </template>
                </b-table>
            </b-collapse>
            <b-row v-if="!addingToContainer && !!permit.event">
                <b-col>
                    <b-badge pill variant="secondary">{{permit.event.lane}}</b-badge>
                    <b-badge pill variant="secondary">{{permit.event.evt_time | timestamp}}</b-badge>
                </b-col>
            </b-row>
            <template #modal-footer="{ ok, cancel, }">
                <b-button variant="primary"
                        @click="continueToContainerDocuments()"
                        :disabled="isSubmitting || (isContainerVisible && permit.container.length === 0)"
                        v-if="!isReadOnly"
                >
                    Save
                    <b-spinner v-if="isSubmitting" small></b-spinner>
                </b-button>
                <b-button variant="secondary" @click="cancel(); clearForm(); ">
                    Cancel
                </b-button>
            </template>
        </b-modal>

        <!-- QRCODE Modal -->
        <b-modal header-bg-variant="success"
                id="qrModal"
                :title="(`${selectedPermit.company===undefined?'':selectedPermit.company.toUpperCase()} - `) + (selectedPermit.lic_plate===undefined?'':selectedPermit.lic_plate.toUpperCase())"
                ok-only
                no-close-on-backdrop>
            <h4 class="text-center text-bold text-uppercase">
                {{ selectedPermit.company }}
            </h4>
            <h2 class="text-center">
                {{ selectedPermit.permit_date.replace(/\+.*/, '') }}
            </h2>
            <h1 class="text-center text-uppercase text-bold">
                {{ selectedPermit.direction.toString() === '1' ? 'IN': 'OUT' }}
            </h1>
            <b-link target="_blank" :href="qrcode" @click="copyToClipboard(selectedPermit.pass_code)">
                <b-img :src="qrcode" fluid center></b-img>
            </b-link>
            <h1 class="text-center text-bold text-uppercase">
                {{ selectedPermit.lic_plate }}
            </h1>
            <h2 class="text-center text-uppercase" v-if="selectedPermit.containers!==undefined">
                <ul class="list-group list-group-flush" v-if="selectedPermit.containers!==null">
                <li class="list-group-item" v-for="(container,i) in selectedPermit.containers.container" :key="i">{{ container===undefined?'':container.no }}</li>
                </ul>
            </h2>
            <h2 class="text-center" v-else>
                -
            </h2>
            <template #modal-footer="{ ok, }">
                <b-button @click="qrcode=null;selectedPermit={lic_plate: '',container: '', direction: '', permit_date: '',};ok();" block variant="primary">
                OK!
                </b-button>
            </template>
        </b-modal>

        <!-- Cancel Confirmation Modal -->
        <b-modal header-class="bg-danger text-white" id="cancelConfirmation">
            <template #modal-title>
                <b-icon icon="exclamation-triangle-fill"></b-icon>
                Cancel Permit Confirmation
            </template>
            <h1 class="text-center font-weight-bolder">WARNING!</h1>
            <h4 class="text-center">This destructive action is not recoverable! </h4>
            <h4 class="text-center">Are you sure to cancel this permit?</h4>
            <b-form-group
                label="Reason"
                label-for="reason"
                label-class="required"
            >
                <b-form-input
                    id="reason"
                    v-model="$v.cancellationForm.desc.$model"
                    :state="validateState('cancellationForm','desc')"
                    type="text"
                    required
                    placeholder="Enter your cancellation reason"
                ></b-form-input>
                <b-form-invalid-feedback>
                This is a required field and max 70 characters.
                </b-form-invalid-feedback>
            </b-form-group>
            <template #modal-footer="{ ok, cancel, hide }">
                <b-button size="sm" variant="outline-danger" @click="cancelPermit(selectedPermit)" :disabled="isCancelling">
                    <i class="fa fa-trash"></i>
                    Yes, Cancel it!
                    <b-spinner v-if="isCancelling" small></b-spinner>
                </b-button>
                <b-button size="sm" variant="secondary" @click="$v.$reset();hide('forget')">
                    Nah, I've changed my mind
                </b-button>
            </template>
        </b-modal>
    </content-wrapper>
</template>

<script>
import Content from "@/components/Layouts/Content";
import ContentWrapper from "@/components/Layouts/ContentWrapper";
import SimplePagination from "@/components/SimplePagination";
import {listGateOdol,setPermitBsims, doubleInQrCode} from "@/services/mware";
/* add */
import {addPermit, setPermitStatus} from '@/services/permits';
import MemberDropDown from "@/components/composable/MemberDropDown";
import {lookupVehicle} from "@/services/vehicles";
import {validationMixin} from "vuelidate";
import {userInfoMixin} from "@/mixins/userInfoMixin";
import {formValidation} from "@/mixins/formValidation";
import {optionalMixin} from "@/mixins/optional";
import {required, maxLength} from "vuelidate/lib/validators";
import Str from "@/helpers/Str";
import {hasOwnProperty, isString} from "@/helpers/Utils";
import {findContainerLocal} from "@/services/bsims";

const formatIsoDateTime = (value) => {
    if (typeof value !== "string") {
        return "-";
    }

    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/);

    if (!match) {
        return value;
    }

    const [, year, month, day, hours, minutes, seconds] = match;

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

export default {
    name: "PermitsOdol",
    components: {
        Content,
        ContentWrapper,
        SimplePagination,
        /* add */
        MemberDropDown,
    },
    mixins: [
        userInfoMixin, validationMixin, formValidation,
        optionalMixin,
    ],
    validations: {
        cancellationForm: {
        desc: {
            required,
            maxLength: maxLength(70),
        }
        },
        container: {
        required,
        maxLength: maxLength(15),
        },
        permit: {
        lic_plate: {
            required,
            maxLength: maxLength(9),
        },
        permit_date: {
            required,
        },
        direction: {
            required,
        },  // 1=in 2=out
        },
        owner: {
        required,
        }
    },
    data: () => ({
        isLoading: false,
        columns: [
            {
                key: "created_at",
                label: "Tanggal",
                formatter: formatIsoDateTime,
            },
            {
                key: "no_pol",
                label: "Lic Plate",
                formatter: (value) => value || "-",
            },
            {
                key: "brand_model",
                label: "Brand Model",
            },
            {
                key: "direction",
                label: "Gate",
            },
        ],
        pagination: {
            current: 1,
            total_items: 0,
            per_page: 10,
            at_last_page: false,
        },
        options: {
            directions: [
                {text: "IN", value: 1},
                {text: "OUT", value: 2},
                {text: "BOTH", value: 3},
            ],
            status: [
                // {text: "Hold", value: 0},
                // {text: "Active", value: 1},
                {text: "Used", value: 3},
            ],
            search: [
                {text: "", value: ""},
                {text: "License Plate", value: "lic_plate"},
                {text: "Brand Model", value: "brand_model"},
            ],
            condition: [
                {text: 'KOSONG', value: 1},
                {text: 'ISI', value: 2},
            ],
            members: [],
            memberVehicles: [],
            pagination: [10, 20, 30, 40, 50, 80, 100],
        },
        searchForm: {
            type: "",
            keywords: "",
            dateType: "permit_date",
            startDate: null,
            endDate: null,
            direction: 3,
            status: 3,
        },
        /* add */
        qrcode: '',
        readonly: {
            lic_plate: true,
        },
        isReadOnly: false,
        isSubmitting: false,
        isLoadingVehicle: false,
        addingToContainer: false,
        isContainerVisible: false,
        permit: {
            lic_plate: "",
            permit_date: "",
            direction: '',  // 1=in 2=out
            cond: 1,  // 1=kosong 2=isi
            container: [],
        },
        permitContainer: [
            {
                key: 'no',
                label: 'Container',
            },
            {
                key: 'voyage',
                label: 'Voyage',
            },
            {
                key: 'action',
                label: 'Action',
            },
        ],
        selectedPermit: {
            lic_plate: '',
            containers: {
                container: [],
            },
            permit_date: '',
            direction: '',
            company: '',
        },
    }),
    methods: {
        applySearch() {
            this.pagination.current = 1;
            this.$refs.table.refresh();
        },
        laneBadgeVariant(lane) {
            if (typeof lane !== "string") {
                return null;
            }

            const normalizedLane = lane.toLowerCase();

            if (normalizedLane.includes("in")) {
                return "primary";
            }

            if (normalizedLane.includes("out")) {
                return "danger";
            }

            return null;
        },
        formatBrandModel(item) {
            const brand = item.brand || item.vehicle_brand || "";
            const model = item.model || item.vehicle_model || "";
            const combined = `${brand} ${model}`.trim();
            return combined || "-";
        },
        extractLane(item) {
            if (item && item.event && item.event.lane) {
                return item.event.lane;
            }
            return item.lane || "-";
        },
        searchParams(ctx) {
            const searchData = {
                per_page: this.pagination.per_page,
                current_page: this.pagination.current,
            };

            if (ctx && ctx.sortBy) {
                const direction = ctx.sortDesc ? "desc" : "asc";
                searchData.order_by = `${ctx.sortBy},${direction}`;
            }

            if (this.searchForm.type && this.searchForm.keywords) {
                searchData[this.searchForm.type] = `%${this.searchForm.keywords}%`;
            }

            const dateType = this.searchForm.dateType || "permit_date";

            if (this.searchForm.startDate) {
                searchData[`${dateType}_start`] = this.searchForm.startDate;
            }

            if (this.searchForm.endDate) {
                searchData[`${dateType}_end`] = this.searchForm.endDate;
            }

            if (this.searchForm.direction) {
                searchData.direction = this.searchForm.direction;
            }

            if (this.searchForm.status !== null) {
                searchData.status = this.searchForm.status;
            }

            return searchData;
        },
        /* add */
        openPermitForm(permit) {
            this.clearForm()
            this.options.memberVehicles = [];
            if (this.can('memberadmin|member')) {
                this.owner = {
                    id: this.member.id,
                    company_name: this.member.company_name,
                }
                this.$nextTick(() => {
                this.$v.owner.$touch()
                });
                this.loadVehicleByMember()
            }
            if (permit !== undefined) {
                this.isReadOnly = true;
                this.$v.permit.$model = { ... permit};
                this.permit.permit_date = this.permit.permit_date.replace(/\+.*/, '')
                let container = this.optional(this.permit, 'container', []);
                if (container && isString(container)) {
                    container = [container]
                }
                this.permit.container = container.map(c => ({ container: c }))
                
                this.isContainerVisible = true;
            }
            this.$bvModal.show('permitModal')
        },
        clearForm() {
            this.bsims_set_permit = { // set permit default value
                in_out: 0,
                no_pol: '',
                data: [],
                qrcode: ''
            };
            this.container = '';
            this.permit = {
                lic_plate: "",
                // container: "",
                permit_date: "",
                direction: '',  // 1=in 2=out
                cond: 1,  // 1=kosong 2=isi
                container: [],
            }
            this.isContainerVisible = false;
            this.selectedDocument = null;
            this.owner = null;
            this.$nextTick(() => {
                this.$v.$reset();
            });
            this.isReadOnly = false;
        },
        async loadVehicleByMember() {
            try {
                this.isLoadingVehicle = true;
                this.readonly.lic_plate = true;
                this.permit.lic_plate = '';

                if(this.owner.text){
                this.owner = this.owner.value
                }
                console.log('this.ownerXD', this.owner);
                const {data: {data: {rows}}} = await lookupVehicle({member: this.owner.id});
                console.log('rows', rows);
                this.options.memberVehicles = Array.isArray(rows.vehicle) ? rows.vehicle : [rows.vehicle];
                console.log('this.options.memberVehicles', this.options.memberVehicles);
                
                this.readonly.lic_plate = false;
            } catch (e) {
                this.options.memberVehicles = [];
            }
            this.isLoadingVehicle = false;
        },
        async addContainerToList(){
            this.$v.container.$touch();
            if (this.$v.container.$anyError) {
                this.$bvToast.toast(`Missing required information!`, {
                title: 'Error!',
                autoHideDelay: 1500,
                variant: 'danger',
                })
                return;
            }
            this.addingToContainer = true;
            this.container = Str.removeAllWhitespaces(this.container)
            const exists = this.permit.container.filter(({container}) => container === this.container)
            if (exists.length > 0) {
                this.$bvToast.toast(`Container ${this.container} already in the list!`, {
                title: 'Duplication Error!',
                autoHideDelay: 1500,
                variant: 'danger',
                })
                this.addingToContainer = false;
                return;
            }
            try {
                const {data: {data: {rows}}} = await findContainerLocal({
                container: this.container,
                direction: this.permit.direction,
                status: 0,
                });
                this.permit.container.push({ no: rows.container.no, voyage: rows.container.voyage });

                // set permit payload for bsims
                console.log('rows TEST', rows);
                this.bsims_set_permit.in_out = rows.container.direction;
                this.bsims_set_permit.no_pol = this.permit.lic_plate;

                this.bsims_set_permit.data = [...this.bsims_set_permit.data, rows.container];
                console.log('addContainerToList TEST', this.bsims_set_permit);

                // set permit testing matikan yang bawah
                // this.bsims_set_permit.qrcode = 'l5s9p6ftxkpyavmzj8h0ho';
                // const set_permit_bsims = JSON.parse(await setPermitBsims(this.bsims_set_permit));
                // console.log('setP now', set_permit_bsims);
                

                this.container = null;
                this.$nextTick(() => {
                this.$v.container.$reset();
                });
                this.addingToContainer = false;
            } catch (e) {
                this.addingToContainer = false;
                if (!hasOwnProperty(e, 'response')) {
                this.$bvToast.toast(`${e.message}`, {
                    title: 'Error!',
                    autoHideDelay: 1500,
                    variant: 'danger',
                })
                return;
                }
            }
        },
        async continueToContainerDocuments() {
            console.log('continueToContainerDocuments');
            /**
             * Need extra confirmation from Pak.Halim
             * about how to submit this form
             * since the initial API only accept 1 or non container
             * and now it becomes 1 or 2 or non
             */
            this.canAddPermit = true;
            return this.addPermit();
        },
        async addPermit() {
            if (!this.canAddPermit) {
                this.$bvToast.toast(`You are not allowed to add Permit!`, {
                title: 'Error!',
                autoHideDelay: 1500,
                variant: 'danger',
                })
                return;
            }
            this.$v.permit.$touch();
            if (this.$v.permit.$anyError) {
                this.$bvToast.toast(`Missing required information!`, {
                title: 'Error!',
                autoHideDelay: 1500,
                variant: 'danger',
                })
                return;
            }
            this.isSubmitting = true;

            // double in qrcode
            try {
                let double_qr = JSON.parse(await doubleInQrCode({ direction: this.permit.direction, no_pol: this.permit.lic_plate }));
                console.log('double_qr', double_qr);

                // test double qr code response
                // this.isSubmitting = false;
                // return;

                if (double_qr.bool) {
                this.$bvToast.toast(`${double_qr.message}`, {
                    title: 'Error!',
                    autoHideDelay: 1500,
                    variant: 'danger',
                })
                this.isSubmitting = false;
                return;
                }
            } catch (e) {
                // do nothing since the check is only optional
                this.$bvToast.toast(`Failed to check double in permit, please contact the administrator!`, {
                title: 'Warning!',
                autoHideDelay: 1500,
                variant: 'danger',
                })
                return;
            }

            try {
                // Some fields are default from now, refer to addPermit service and see for default value
                // @see @/services/permit.js
                const data = { ... this.permit };
                data.user_id = this.loggedInUser.id;
                data.user_name = this.loggedInUser.username
                const {data: {data: {pass}}} = await addPermit(data);
                console.log('addPermit pass', pass);
                this.selectedPermit.containers = { container: [] };
                if( data.container != null ) {
                if (!Array.isArray(data.container)) {
                    this.selectedPermit.containers.container = [data.container];
                } else {
                    this.selectedPermit.containers.container = data.container;
                }
                }
                this.selectedPermit.lic_plate = this.permit.lic_plate;
                this.selectedPermit.direction = data.direction;
                this.selectedPermit.company = this.owner.company_name;
                this.selectedPermit.permit_date = pass.permit_date;
                this.qrcode = `/static/qrcode/${pass.qr_code}`;
                this.$bvToast.toast(`Add Permit Success!`, {
                title: 'Congratulation!',
                autoHideDelay: 1500,
                variant: 'success',
                })
                this.$bvModal.hide('permitModal')
                this.$bvModal.hide('sppb');
                this.$bvModal.show('qrModal')

                // set permit
                if (this.selectedPermit.containers.container.length > 0) {
                this.bsims_set_permit.qrcode = pass.qr_code;
                const set_permit_bsims = JSON.parse(await setPermitBsims(this.bsims_set_permit));
                console.log('setP addPermit', set_permit_bsims);
                }

                this.clearForm();
                this.$refs.table.refresh();
            } catch (e) {
                if (!hasOwnProperty(e, 'response')) {
                this.$bvToast.toast(`${e.message}`, {
                    title: 'Error!',
                    autoHideDelay: 1500,
                    variant: 'danger',
                })
                return;
                }
            }
            this.isSubmitting = false;
        },
        async cancelPermit(permit) {
            this.isCancelling = true;
            try {
                this.$v.cancellationForm.$touch();
                if (this.$v.cancellationForm.$anyError) {
                this.$bvToast.toast(`Missing required information!`, {
                    title: 'Error!',
                    autoHideDelay: 1500,
                    variant: 'danger',
                })
                return;
                }

                const data = {
                permit_id: permit.id,
                status: 0,
                username: this.loggedInUser.username,
                desc: this.cancellationForm.desc,
                }
                await setPermitStatus(data);
                this.isCancelling = false
                this.$nextTick(() => {
                this.$v.$reset();
                });
                this.$bvModal.hide('cancelConfirmation');
                this.$refs.table.refresh();
            } catch (e) {
                this.isCancelling = false
                if (!hasOwnProperty(e, 'response')) {
                this.$bvToast.toast(`${e.message}`, {
                    title: 'Error!',
                    autoHideDelay: 1500,
                    variant: 'danger',
                })
                return;
                }
            }
        },
        /* end add */
        async loadPage(ctx) {
            this.isLoading = true;
            this.pagination.total_items = 0;
            this.pagination.at_last_page = false;

            try {
                const {data: {data}} = await listGateOdol(this.searchParams(ctx));
                
                const items = Array.isArray(data) ? data : [data];
                const normalized = items
                    .filter((item) => !!item)
                    .map((item) => ({
                        ...item,
                        direction: item.direction === 1 ? "IN" : "OUT",
                        // brand_model: this.formatBrandModel(item),
                        // lane: this.extractLane(item),
                    }));
                console.log('listGateOdol', items);
                this.pagination.total_items = normalized.length;
                this.pagination.at_last_page = this.pagination.total_items < this.pagination.per_page;
                return normalized;
            } catch (e) {
                this.pagination.at_last_page = true;
                return [];
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>